import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot } from "@angular/router";

import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { BusinessFunctionService } from "./businessfunction.service";
import { AuthService } from "./auth.service";
import { ConfigurationService } from "./configuration.service";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { AuthenticationMode } from "../enums/authenticationMode";

@Injectable()
export class AuthGuardService {

    constructor(private auth: AuthService, private router: Router, private businessFunctionService: BusinessFunctionService, private configurationService: ConfigurationService) {
    }

    canActivate(activatedRoute: ActivatedRouteSnapshot): Observable<boolean> {
        const defaultRoute: string = activatedRoute.params['defaultroute'] as string;
        if (defaultRoute !== undefined) {
            return this.businessFunctionService.getAll().pipe(
                map(bfs => {
                    this.auth.businessFunctions = bfs as IBusinessFunction[];
                    const matchedBusinessFunction: IBusinessFunction | null = AuthService.getBusinessFunctionByDefaultRoute(defaultRoute);
                    if (matchedBusinessFunction != null) {
                        if (matchedBusinessFunction.authenticationRequired && AuthService.user == null) {
                            this.configurationService.getAuthenticationMode().subscribe((mode: number) => {
                                if (mode === AuthenticationMode.DPASS) {
                                    window.location.assign(`/authenticateuser`);
                                } else {
                                    this.router.navigate([`${defaultRoute}/logon`]);
                                }
                            });
                            return false;
                        } else {
                            // set the business function here.
                            this.auth.businessFunction = matchedBusinessFunction;
                        }
                        return true;
                    }
                    this.router.navigate(["/splash"]);
                    return false;
                })
            );
        } else {
            // if business function name is blank or not matched with the database direct to the splash screen.
            this.router.navigate(["/splash"]);
            return of(false);
        }
    }
}
